import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const CalendarCheckIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="none"
            viewBox="0 0 24 24"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                stroke="currentColor"
                d="M10 17.5H3.2a.7.7 0 0 1-.7-.7V4.2c0-.4.3-.7.7-.7h13.6c.4 0 .7.3.7.7V10m-12-8v3m9-3v3m-12 2.5h15"
            />
            <path stroke="currentColor" strokeLinecap="square" d="m15 18 1.5 1.5 3-4" />
            <path stroke="currentColor" d="M12.5 17.5a5 5 0 1 0 10 0 5 5 0 0 0-10 0Z" />
        </svg>
    </IconWrapper>
)
